import { buildSearchIndex } from "./searchIndex";

export const fastSearch = ({ city, query, category }) => {
  const data = buildSearchIndex();
  const q = query?.toLowerCase();

  return data.filter((item) => {
    if (city && item.city !== city) return false;
    if (category && item.category !== category) return false;
    if (!q) return true;

    return (
      item.name.toLowerCase().includes(q) ||
      item.area.toLowerCase().includes(q) ||
      item.details.toLowerCase().includes(q) ||
      item.category.includes(q)
    );
  });
};
